import React from 'react'

type ProductOverviewCopy = {
  overviewTitle: string
  overviewCopy: string
}

export const ProductOverviewSection: React.FC<{ copy: ProductOverviewCopy }> = ({ copy }) => {
  return (
    <section id="product" className="landing-section">
      <div className="container landing-overview">
        <div>
          <p className="landing-eyebrow">NexusWorkforce360</p>
          <h2>{copy.overviewTitle}</h2>
        </div>
        <p>{copy.overviewCopy}</p>
      </div>
    </section>
  )
}
